<scaffold-dialog [title]="data.title" [fit]="true">
  <div scaffoldDialogBody>
    <p>{{data.message}}</p>
  </div>
  <div scaffoldDialogButtons>
      <button nbButton status="neutral" (click)="onNoClick()">{{'cancel'| translation}}</button>
      <span>
        <button style="margin-right: 8px;" nbButton status="secondary" (click)="onYesClick()">{{'discard'| translation}}</button>
        <button nbButton status="primary" cdkFocusInitial (click)="onYesClick(true)">{{'save'| translation}}</button>
      </span>
  </div>
</scaffold-dialog>
